import React from 'react'
import { translate, Trans } from 'react-i18next'

import LinkBlocksImg from '../components/LinkBlocksImg'
import ScrollToTopOnMount from '../components/ScrollToTopOnMount'

import di1min from '../assets/img/decorating-interiors/di1min-min.jpg'
import di2min from '../assets/img/decorating-interiors/di2min-min.jpg'
import di3min from '../assets/img/decorating-interiors/di3min-min.jpg'
import di4min from '../assets/img/decorating-interiors/di4min-min.jpg'
import di5min from '../assets/img/decorating-interiors/di5min-min.jpg'
import di6min from '../assets/img/decorating-interiors/di6min-min.jpg'


const T2 = (props) => {
  const arrImgmin = [ di1min, di2min, di3min, di4min, di5min, di6min ]
  const arrImgfull = [
    { src: process.env.PUBLIC_URL + '/assets/di1.jpg'},
    { src: process.env.PUBLIC_URL + '/assets/di2.jpg'},
    { src: process.env.PUBLIC_URL + '/assets/di3.jpg'},
    { src: process.env.PUBLIC_URL + '/assets/di4.jpg'},
    { src: process.env.PUBLIC_URL + '/assets/di5.jpg'},
    { src: process.env.PUBLIC_URL + '/assets/di6.jpg'}
  ]
  return(
    <LinkBlocksImg itemsmin={arrImgmin} itemsfull={arrImgfull} url='/' >
      <ScrollToTopOnMount />
      <Trans i18nKey='T2'>
        <p>
          Приміщення ресторанів, кафе, торгових центрів професійно оздоблені оригінальними рослинами, зеленими стінами, стелями, дизайнерськими композиціями та вміло підібраними стильними кашпо. Це виразний знак високого статусу, сильного бренду та дбайливе ставлення до естетичних смаків клієнта.
        </p>
        <p className="prise">
          Вартість послуги озеленення простору залежить від завдань, які необхідно втілити в життя. 
          Складність конструкцій, якість та кількість кашпо та вазонів, вид та розмір рослин – все це є складовою ціноутворення послуги озеленення приміщення. Та завдяки креативним ідеям і бажанню максимально ефективно впоратися з задачами клієнта студія фітодизайну «VAZON» знайде рішення по прийнятних цінах для Вашого бюджету. <br/>
          Ваше бажання – це наше завдання!
        </p>
      </Trans>
    </LinkBlocksImg>
  )
}

export default translate('translations')(T2)


// WEBPACK FOOTER //
// ./src/page/T2.jsx